// extracted by mini-css-extract-plugin
export default {"dropdown":"DropDownMenuWrapper_dropdown__QIXb+","active":"DropDownMenuWrapper_active__itzTA"};